Vue.component('app-container', {
    delimiters: ['[[', ']]'],
    template: `  
        <div id="wrap">         
            <div>
                
                <header class="main-header main-header-overlay">
                    <menu-header></menu-header>
                </header>
            
                <main id="content" class="content">
                    
                    <content-intro></content-intro>

                    <!-- <client-partner></client-partner> -->

                    <section id="how" class="vc_row bg-no-repeat pt-15 pb-30" style="background-image: url(./assets/demo/bg/bg-76-sp.jpg); background-position: -90% 80%;">
                        <div class="container">
                            <content-how></content-how>

                            <content-audience></content-audience>

                            <div id="features">
                                <content-functionalities></content-functionalities>
                            </div>

                            <!-- <div class="lqd-space visible-lg visible-md" style="height: 130px;"></div>
                            <div class="row d-flex flex-wrap align-items-center">
                                <content-video></content-video>
                            </div> -->
                        </div>
                    </section>

                    <section class="vc_row pt-90 pb-90 bg-no-repeat" style="background-image: url(./assets/demo/bg/bg-77-sp.jpg); background-position: 500% 0%;">
                        <div class="container">
                            <content-examples></content-examples>
                            <div class="lqd-space visible-lg visible-md- mb-200"></div>
                            <!-- <content-releases></content-releases> -->
                        </div>
                    </section>

                    <!-- <section class="vc_row pt-50 pb-50">
                        <div class="container">
                            <content-statistics></content-statistics>
                        </div>
                    </section> -->

                    <!-- <section class="vc_row bg-no-repeat bg-sm-none pt-90 pb-50" style="background-image: url(./assets/demo/bg/bg-78-sp.jpg); background-position: 12% 35%;">
                        <div class="container">
                            <content-testimonials></content-testimonials>
                            <div class="lqd-space visible-md visible-lg" style="height: 400px;"></div>
                        </div>
                    </section> -->

                    <section id="pricing" class="vc_row bg-cover pt-60 pb-100" style="background-image: url(./assets/demo/bg/bg-79-sp.jpg); background-position: center top;">
                        <div class="container">
                            <content-pricing></content-pricing>
                            <div class="lqd-space visible-lg visible-md" style="height: 100px;"></div>
                            <!-- <content-blog></content-blog> -->
                        </div>
                    </section>
                    
                </main>
                
                <footer class="main-footer pt-120 pb-70">
                    
                    <section class="vc_row">
                        <div class="container">
                            <content-footer></content-footer>
                        </div>
                    </section>

                    <section class="vc_row pt-60">
                        <content-social></content-social>
                    </section>
                    
                </footer>

            </div>

            <download-app ref="download-app"></download-app>
            <contact-beta-tester ref="contact-beta-tester"></contact-beta-tester>
            <contact-us ref="contact-us"></contact-us>
            <contact-enterprise ref="contact-enterprise"></contact-enterprise>
            <contact-partner ref="contact-partner"></contact-partner>
            <content-spartacus-lab ref="content-spartacus-lab"></content-spartacus-lab>

        </div>
    `,
    props: {
        
    },
    data: function () {
        return {
            
        }
    },
    mounted(){
        
    },
    methods: {
        
    },
});